import { useEffect } from 'react';

/**
 * A SPA has one document, so each route sets `<title>` on mount — that is what
 * keeps tab titles and browser history entries informative.
 */
export function usePageTitle(title: string): void {
  useEffect(() => {
    document.title = title;
  }, [title]);
}
